import CreateVisit from '../components/templates/create';

export const CreateVisitContainer = () => {
  return <CreateVisit />;
};
